export default {
      id: "oc-res-region-usage",
      viewBox: "0 0 1028 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-region",
      toString: function () {
        return this.url;
      }
    }